module.exports = __webpack_public_path__ + "1642699981952/static/media/banner_candidate_jobs_desktop.f751e219.svg";